import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import simplebar from "simplebar-vue";
import BaseMixer from "../../BaseMixer";
import TimerMinute from "@/components/clockWork/timerMinute.vue";
import { IDayViewProjectModeEntriesDTO } from "@/store/models/workView/dayViewProjectModeEntries";
let DayViewProjectEntryComponent = /** @class */ (() => {
    var _a;
    let DayViewProjectEntryComponent = class DayViewProjectEntryComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.count = 0;
            this.totalSecondsForAllUsers = 0;
        }
        workviewTooltip(value) {
            if (value != null || value != "") {
                return value.length > 23 ? value : null;
            }
        }
        created() {
            this.totalTime();
            if (this.calculateTheDurationForRunning != true) {
                this.intervalId = setInterval(() => {
                    this.totalSecondsForAllUsers = this.totalSecondsForAllUsers + this.count * 60;
                }, 60 * 1000);
            }
            this.emitTotalSeconds(this.totalSecondsForAllUsers);
        }
        destroyed() {
            clearInterval(this.intervalId);
        }
        hoursAndMinutes(users) {
            if (!users.isRunning) {
                var hours = Math.floor(users.sumOfTotalTimeForUsers / 3600);
                var minutes = Math.floor((users.sumOfTotalTimeForUsers % 3600) / 60);
                if (hours <= 1) {
                    return `${hours}h ${minutes}m`;
                }
                else if (hours > 1) {
                    return `${hours}h ${minutes}m`;
                }
            }
            return "";
        }
        handleSeconds(user, totalSeconds) {
            user.emittedSecondsValue = totalSeconds;
        }
        totalTime() {
            for (var taskList of this.dayViewProjectModeEntry.dayEntriesTask) {
                for (var user of taskList.dayEntriesTaskUser) {
                    if (user.isRunning) {
                        this.count++;
                    }
                    if (this.calculateTheDurationForRunning == true && user.endTime == null) {
                        this.totalSecondsForAllUsers += 0;
                    }
                    else {
                        this.totalSecondsForAllUsers += user.sumOfTotalTimeForUsers;
                    }
                }
            }
        }
        get calculateTheDurationForRunning() {
            for (var taskList of this.dayViewProjectModeEntry.dayEntriesTask) {
                for (var user of taskList.dayEntriesTaskUser) {
                    if (user.isRunning) {
                        const day = new Date();
                        const toDay = day.getDate();
                        const anyDay = new Date(user.dayEntryDate);
                        var comonDay = anyDay.getDate();
                        if (toDay != comonDay) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                }
            }
            return false;
        }
        get totalTimeForProjects() {
            var hours = Math.floor(this.totalSecondsForAllUsers / 3600);
            var minutes = Math.floor((this.totalSecondsForAllUsers % 3600) / 60);
            if (hours > 0) {
                return `${hours}h ${minutes}m`;
            }
            else {
                return `${minutes}m`;
            }
        }
        emitTotalSeconds(totalSeconds) {
            this.$emit("seconds", totalSeconds);
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IDayViewProjectModeEntriesDTO !== "undefined" && IDayViewProjectModeEntriesDTO) === "function" ? _a : Object)
    ], DayViewProjectEntryComponent.prototype, "dayViewProjectModeEntry", void 0);
    DayViewProjectEntryComponent = __decorate([
        Component({
            name: "DayViewProjectEntryComponent",
            components: {
                TimerMinute,
                simplebar,
            },
        })
    ], DayViewProjectEntryComponent);
    return DayViewProjectEntryComponent;
})();
export default DayViewProjectEntryComponent;
